import { api, unwrap } from "./httpClient";

export interface CreateSupportMessagePayload {
  subject: string;
  message: string;
}

export interface CreateSupportMessageResponse {
  ok: boolean;
  roomId: number;
  messageId: number;
}

export const createSupportMessage = (payload: CreateSupportMessagePayload) =>
  unwrap<CreateSupportMessageResponse>(
    api({ method: "POST", url: "/support", data: payload })
  );


